export const themeOptions = {
  LOCAL_STORAGE_KEY: "nova-theme",
} as const
